import React, { useContext } from 'react';
import { AsyncComponent } from '@twigeducation/async-component';
import { withSignoutRedirect, Context } from '@twigeducation/oidc-client-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AsyncComponentError from '../AsyncComponentError';

const NavbarComponent = props => (
    <AsyncComponent appName="ms-navbar-mfe" componentName="Navbar" errorComponent={AsyncComponentError} {...props} />
);

const NavbarWithLogoutHandler = ({ onLogout, featureFlags, ...props }) => {
    // eslint-disable-next-line react/prop-types
    const rosteringDeprecated = !!(featureFlags && featureFlags['rtk-rostering-deprecations']);
    const { userManager } = useContext(Context);

    const handleLogout = shouldLogout => {
        if (shouldLogout) {
            if (rosteringDeprecated) {
                userManager.signoutRedirect({
                    post_logout_redirect_uri: window.config.SIGNIN_REDIRECT_URL,
                });
            } else {
                onLogout();
            }
        } else {
            window.location.href = window.config.PRODUCT_SELECTION_URL;
        }
    };

    return <NavbarComponent {...props} featureFlags={featureFlags} onLogout={handleLogout} />;
};

NavbarWithLogoutHandler.propTypes = {
    onLogout: PropTypes.func.isRequired,
    featureFlags: PropTypes.shape({}),
};

NavbarWithLogoutHandler.defaultProps = {
    featureFlags: {},
};

const mapStateToProps = state => ({ userInfo: state.userInfo, hostApp: 'MS', featureFlags: state.featureFlags });
export default withSignoutRedirect(() => {})(connect(mapStateToProps)(NavbarWithLogoutHandler));
